export default __webpack_public_path__ + "static/media/remodel5.080827de.png";